// extracted by mini-css-extract-plugin
export default {"modal-salvar-filtro":"ModalSavingFilters_modal-salvar-filtro__JSSHT","btn-save":"ModalSavingFilters_btn-save__OJgOY","btn-cancel":"ModalSavingFilters_btn-cancel__NeKov"};